import {html} from 'lit';

export function videoExternal(videoUrl: string) {
  return html`
  <div class="externalembed__content-wrapper">
  <iframe scrolling="no" class="video__content" allow="autoplay *;fullscreen *" allowfullscreen="true"
    src="${videoUrl}" sandbox="allow-popups allow-same-origin allow-scripts" width="600" height="400"></iframe>
  </div>
  `;
}
